import { constructionSafety, logisticsAsset, logisticsSafety, manufacturingSteel } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';
import digitaltwin from '@src/assets/images/digitaltwin/video/traffic.mp4';

export default {
  desc: 'Smart City là một khái niệm đang phát triển nhanh chóng trong các đô thị hiện đại, hướng tới vận hành thành phố hiệu quả bằng cách ứng dụng các công nghệ và hạ tầng tiên tiến nhất.',
  keywords: 'Smart City, digital twin, digital transformation, thành phố tương lai, smart city, digital twin, digital transformation, thanh pho tuong lai.',
  ogSite: 'Các trường hợp ứng dụng triển khai Smart City (Smart City)',
  title: 'Các trường hợp ứng dụng triển khai Smart City (Smart City)',
  ogUrl: 'https://orbro.io/vi/blog/example-of-smart-city',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDkFVkNhGYhAjBJLQh-TO_MrDW5dZ9e675klRxgK1f4x67wU6ADQnAzVhSAqDCJ5a6mjIlcP3clmtu92HV05SxhzPTDf1NScGbhZaAOxxAakyFJm0bwewGqWjuE1NJoM86xI5RkwtjQZ4WFYc6d0Hrid-pszPZbQGf1gYPMDqDwORsg5wyGW5bNgU7KKeOTMzrkt78Yr5lYcchyCNmpn2NmzJazzotGsmI9T33V6K3T6xqraKPVNfNkg6odqKHbGpbE7knODw-Ps7LNMLRhHIAZIM9lduTSX896wr7cZscafS5TDVi8cSC0ERUhdb3YwCRgKm0YqSsnVcCJcAbu4evdtoUzdMcjZAIfKR_kw7HgXI42LaA4C-PhxW2jQQKyD9UIxoOFPmJFIh6q7vIHbg3k3cAUc2dxW0Z6hfKLB2k10q0aubzcnWFJnEPSibJNaZJA0fslRcEQTOOSq7qH3K-9HiRproHejfmIxqYsRayvAnKXQPSJyG6cmWTKw2ctEcRwcsQV7cMU2H5VMEc-s5BYkjOqQe6yylbCUXzQ8qYVwls2h-mstfcyt2phYijwZXPHjEY0Xd1KSUErYHTSCWx_A1JKCL30IryNxWX6ejXVr4rzx9VOXpS53IYlHEz2WJTk6LjBccSU2u9lAv_gwAiZTmTSoRX658UQv-7kdx_Et7OVcWSg4GdQpFTDS9mF8huuN39CfL2Tm9qVy2j5jAl-gTQ4o4bnPhaHz9NMoaM-qoTdDt4Q5C1ysaxNReONUY8phy-5RgTgHszfiRXjSpTP_fjzv_dGumhP0V_Rf6ndfluYR6Mg1BHCVhSUG62aDV8bGqdS2oYAmGPYgbN99KcLyQgySVflbWa6wC_fOGkLNeso6n_M6C7otFKqjX9XmB3s6GUBTaS3JiqqQJ-N9qGtjKI86za8HY7i9lxAJEh4iY2FSXw3kIW-m6OTvQbenmldQlgE6hB_Fl8rm6ATKKLAhsxwx5fMKD16IV2hBFuQ9wpnIjLhw1XLzIy0R5Pka1Mygfo6no04iZU4LAApDVkphY4k958mwN4tg_wyl3L63jjST8taRHacU0M-4ADiu0tC2vJzWH1XQwiSedBQQTTUMuydsHQCMYlanG9WhyhybHTxRIA7pUX7-wpNqkFiWCrT9TPNbHg-ON5nQrBGyDUZUb5fC-U4EkUN0a-Pe-CHJJ6bZd1m_oCpzdulGMPnK-4_VjWBJAiQRteQ8QTUKNhmQj2yEnZwCJQZZSTpk1IlGzgHiJ_BsIYyD_a3z-ysShhTuE9hG_57y4aIz8Rf6ZsrXTp1OeEHkNkCvjH7ZnbdABz0u_QyshaMMfU7EKVUbH6tIXiym1yOX6upY9M_6JtOTgtlulM87kVzPjPoy47O2YEq7mcAOwMBRmDb6gfW2J0t7PuaFMgTQAi4XiKpM5Pf_NhIK-wNtRCAhcSD9WCAd1CIxJ-CrcG3xn77PYV4NQRe0Oi2KQCyqG3frUstyWuJuSAeYrdYhBRBkDG6OoVG48EshJwneIwytpeURilKCKLLPt64ls45oiR-ZMwMxmdpfsCMct--L=w2010-h1214',
  ogType: 'website',
  date: '2024-01-08',
  tag1: '#SmartCity',
  tag2: '#DigitalTwin',
  tag3: '#DigitalTransformation',
  tag4: '#Thanhphotuonglai',
  text: [
    {
      head: 'Các dự án Smart City điển hình',
      subHead: '',
      desc: 'Smart City là một khái niệm đang phát triển nhanh chóng trong các đô thị hiện đại, hướng tới vận hành thành phố hiệu quả bằng cách ứng dụng các công nghệ và hạ tầng tiên tiến nhất. Thông qua các cảm biến, công nghệ IoT, Big Data và nhiều công cụ khác, Smart City thu thập và phân tích dữ liệu trong các lĩnh vực đa dạng như giao thông, năng lượng, môi trường, nhằm nâng cao chất lượng cuộc sống của người dân và hướng đến sự phát triển bền vững. Smart City đang trở thành mô hình đô thị tương lai, được các thành phố trên toàn cầu phát triển thông qua đổi mới và hợp tác.\nTheo đó, chúng ta hãy cùng tìm hiểu các trường hợp xây dựng Smart City trên khắp thế giới dưới đây.',
      dot: '',
    },
    {
      head: 'Smart City Singapore',
      subHead: '',
      desc: 'Singapore là quốc gia đi đầu trong việc triển khai Smart City một cách có hệ thống. Các cảm biến và thiết bị IoT đa dạng được lắp đặt trong thành phố giúp giám sát tình trạng giao thông và thực hiện quản lý giao thông hiệu quả. Ngoài ra, Singapore còn nâng cao hiệu quả năng lượng thông qua công nghệ Smart Grid, đồng thời tăng cường an toàn thông qua tự động hóa các cơ sở công cộng và mạng lưới CCTV thông minh.',
      dot: '',
    },
    {
      head: 'Smart City Tokyo',
      subHead: '',
      desc: 'Tokyo đang thúc đẩy nhiều dự án khác nhau nhằm thông minh hóa đô thị. Thành phố đã áp dụng các công nghệ như chiếu sáng thông minh, tự động hóa tòa nhà và cảm biến đo lường bụi mịn để giám sát môi trường. Hệ thống giao thông thông minh giúp giảm ùn tắc và nâng cao hiệu quả của thành phố.',
      dot: '',
    },
    {
      head: 'Smart City Barcelona',
      subHead: '',
      desc: 'Barcelona đang theo đuổi sự phát triển đô thị bền vững thông qua Smart Grid, mạng lưới cảm biến không dây và số hóa giao thông công cộng. Bằng cách sử dụng phân tích Big Data, thành phố tối ưu hóa việc thu gom rác thải và mức tiêu thụ năng lượng, đồng thời nỗ lực xây dựng một nền tảng Smart City để quản lý hiệu quả các chức năng đa dạng của đô thị.',
      dot: '',
    },
    {
      head: 'Smart City Seoul',
      subHead: '',
      desc: 'Seoul đang đổi mới cơ sở hạ tầng đô thị thông qua việc xây dựng Smart City. Việc triển khai Smart Grid và số hóa giao thông công cộng đã góp phần nâng cao hiệu quả năng lượng và tiện lợi trong giao thông. Ngoài ra, Seoul còn tập trung vào việc tích hợp và phân tích nhiều dữ liệu khác nhau thông qua nền tảng Smart City để tăng cường tiện ích và an toàn cho người dân.',
      dot: '',
    },
    {
      head: 'Phương pháp xây dựng Smart City',
      subHead: '',
      desc: 'Để xây dựng một Smart City cần có nhiều công nghệ và chiến lược khác nhau. Dưới đây là giải thích ngắn gọn về các phương pháp chính để xây dựng Smart City:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cải thiện hạ tầng',
      desc: 'Smart City yêu cầu một hạ tầng kỹ thuật số được tăng cường. Xây dựng mạng lưới băng thông rộng tốc độ cao và 5G để cho phép truyền dữ liệu theo thời gian thực và đảm bảo các thiết bị kết nối internet hoạt động hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ứng dụng Big Data và AI',
      desc: 'Việc thu thập và phân tích lượng lớn dữ liệu để tối ưu hóa hoạt động của thành phố là yếu tố cốt lõi. Ứng dụng công nghệ Big Data và AI để phân tích và dự đoán dữ liệu phát sinh trong các lĩnh vực đa dạng như giao thông, môi trường, năng lượng theo thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giới thiệu cảm biến thông minh và công nghệ IoT',
      desc: 'Triển khai các cảm biến đa dạng và công nghệ IoT trong thành phố để thu thập dữ liệu về giao thông, môi trường, năng lượng... theo thời gian thực. Điều này giúp nâng cao tiện ích cho người dân và tối ưu hóa vận hành đô thị.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hệ thống năng lượng và lưới điện thông minh (Smart Energy & Grid System)',
      desc: 'Giới thiệu năng lượng tái tạo và xây dựng hệ thống Smart Grid để nâng cao hiệu quả năng lượng và tối ưu hóa tiêu thụ năng lượng. Hệ thống quản lý năng lượng thông minh sẽ tối ưu hóa lượng năng lượng sử dụng và thúc đẩy tiêu thụ năng lượng bền vững.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Số hóa giao thông công cộng',
      desc: 'Số hóa hệ thống giao thông công cộng bằng cách cung cấp thông tin thời gian thực, hệ thống đặt chỗ, giới thiệu phương tiện tự lái... nhằm giảm ùn tắc giao thông và giảm thiểu tác động đến môi trường.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Xây dựng nền tảng Smart City',
      desc: 'Xây dựng nền tảng Smart City để thu thập, quản lý dữ liệu hiệu quả và cung cấp dữ liệu mở cho người dân và doanh nghiệp. Điều này đóng vai trò quan trọng trong việc tối ưu hóa vận hành đô thị và khuyến khích sự tham gia của người dân.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường an ninh mạng (Cybersecurity)',
      desc: 'Trong Smart City, nhiều loại dữ liệu được trao đổi theo thời gian thực, do đó an ninh mạng là một nhiệm vụ cốt lõi. Áp dụng hệ thống bảo mật mạnh mẽ để bảo vệ hệ thống và quản lý an toàn thông tin cá nhân của người dân.',
      dot: '',
    },
    {
      head: 'Ưu điểm của Smart City',
      subHead: 'Vận hành đô thị hiệu quả',
      desc: 'Smart City có thể quản lý hiệu quả các hoạt động đô thị như giao thông, năng lượng, tài nguyên nước, xử lý rác thải thông qua thu thập và phân tích dữ liệu theo thời gian thực. Điều này giúp tối ưu hóa các chức năng của thành phố và đảm bảo cuộc sống hàng ngày của người dân diễn ra thuận lợi.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tối ưu hóa luồng giao thông',
      desc: 'Thông qua việc số hóa giao thông công cộng, giới thiệu công nghệ tự lái..., ùn tắc giao thông sẽ giảm và luồng giao thông được tối ưu hóa. Điều này giúp người dân di chuyển thuận lợi hơn và giảm thiểu tác động tiêu cực đến môi trường.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hiệu quả năng lượng và bền vững',
      desc: 'Smart City tối ưu hóa tiêu thụ năng lượng và thúc đẩy sử dụng năng lượng bền vững thông qua Smart Grid, năng lượng tái tạo và các công nghệ tiết kiệm năng lượng. Nhờ đó, có thể giảm gánh nặng cho môi trường và tiết kiệm chi phí năng lượng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thúc đẩy sự tham gia của người dân',
      desc: 'Smart City cung cấp nhiều phương tiện khác nhau để người dân có thể tham gia vào vận hành đô thị. Thông qua dữ liệu mở, ứng dụng di động..., người dân có thể tham gia vào quá trình ra quyết định của thành phố và góp phần tạo nên một môi trường tốt đẹp hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao an toàn',
      desc: 'Smart City nâng cao an toàn đô thị bằng cách giới thiệu CCTV thông minh, hệ thống ứng phó tình huống khẩn cấp và các biện pháp an toàn phòng ngừa. Khả năng phòng chống tội phạm và ứng phó tình huống khẩn cấp được cải thiện thông qua giám sát theo thời gian thực và phân tích Big Data.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phát triển kinh tế',
      desc: 'Việc xây dựng Smart City có thể thu hút các công nghệ và ngành công nghiệp mới, đồng thời thúc đẩy kinh tế địa phương. Các doanh nghiệp phát triển và ứng dụng công nghệ Smart City đóng vai trò tạo việc làm và thúc đẩy phát triển kinh tế.',
      dot: '',
    },
    {
      head: 'Triển vọng của Smart City',
      subHead: '',
      desc: 'Tương lai của Smart City được dự đoán sẽ phát triển thành một môi trường đô thị đổi mới và kết nối hơn nữa. Các công nghệ tiên tiến như Big Data, AI, IoT sẽ được tích hợp để quản lý hiệu quả vận hành đô thị, và theo đó, tính bền vững của thành phố sẽ được nhấn mạnh trên nhiều khía cạnh như giảm ùn tắc giao thông, nâng cao hiệu quả năng lượng, bảo vệ môi trường. Người dân được dự kiến sẽ trải nghiệm các dịch vụ cá nhân hóa và mức độ tham gia cao hơn, từ đó tiện ích trong cuộc sống đô thị sẽ được cải thiện đáng kể. Ngoài ra, tầm quan trọng của việc xây dựng Smart City ở cấp độ toàn cầu đang ngày càng được đề cao, và xu hướng các quốc gia trên thế giới tham khảo mô hình đô thị này sẽ ngày càng tăng. Sự phát triển của kiến trúc và thiết kế đô thị thông minh cũng được mong đợi, và người dân được dự đoán sẽ tận hưởng cuộc sống trong một thành phố an toàn và thông minh hơn.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/vi/enterprise/manufacturing/steel',
      },
    ],
  },
};
